import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import TimelineCharts from '@blade-sxp/monitor/components/echarts/timeline-charts.vue';
let default_1 = class default_1 extends Vue {
    speed;
    dataX;
    timeType;
    speedUnit;
    interval;
    get option() {
        return {
            title: {
                text: this.$t('speedTitle') + this.speedUnit + ')',
                show: true,
                textStyle: {
                    // 主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                    fontFamily: 'Arial, Verdana, sans...',
                    fontSize: 13,
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    color: '#485465',
                },
            },
            tooltip: {
                trigger: 'axis',
                //   formatter(data: any) {
                //     return (
                //       data[0].name +
                //       `</br><span style="display: inline-block; border-radius: 50%; width: 8px;height: 8px;background-color: #2fc25b;margin-right:5px;"></span>入园速度：` +
                //       data[0].value +
                //       `（人/min）`
                //     );
                //   },
            },
            legend: {
                right: 0,
                data: [this.$t('entrySpeed')],
            },
            dataZoom: [
                {
                    type: 'slider',
                    start: 0,
                    end: 100,
                    width: '80%',
                    left: '10%',
                    handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                    brushSelect: false, // 是否开启刷选功能,默认true
                },
            ],
            grid: {
                left: '20',
                right: '35',
                bottom: '10%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: [],
                axisLabel: {
                    show: true,
                },
            },
            yAxis: {
                type: 'value',
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dashed',
                    },
                },
            },
            series: [
                {
                    name: this.$t('entrySpeed'),
                    type: 'line',
                    stack: '总量',
                    data: [],
                    itemStyle: {
                        normal: {
                            color: '#2FC25B',
                            lineStyle: {
                                color: '#2FC25B', // 折线颜色
                            },
                        },
                    },
                },
            ],
        };
    }
    handleResize() {
        this.$refs.refCharts && this.$refs.refCharts.onResize();
    }
    onDataZoomChange(timeStart, timeEnd) {
        this.$emit('on-data-zoom-change', timeStart, timeEnd);
    }
};
__decorate([
    Prop()
], default_1.prototype, "speed", void 0);
__decorate([
    Prop()
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "timeType", void 0);
__decorate([
    Prop()
], default_1.prototype, "speedUnit", void 0);
__decorate([
    Prop()
], default_1.prototype, "interval", void 0);
default_1 = __decorate([
    Component({
        name: 'SpeedCharts',
        components: {
            TimelineCharts,
        },
        i18n: {
            messages: {
                'en-us': {
                    speedTitle: 'Queuing speed(person/',
                    entrySpeed: 'Entry speed',
                },
                zh: {
                    speedTitle: '排队速度(人/',
                    entrySpeed: '入园速度',
                },
            },
        },
    })
], default_1);
export default default_1;
